import { Button, Stack, Typography } from '@mui/material'
import { COLORS } from 'app-constants'
import { ReactComponent as AstronautGraphic } from 'assets/onboarding/astronaut.svg'
import { useRecoilValue } from 'recoil'
import { authenticatedUserAtom } from 'state'

const TrialEnded = () => {
  const user = useRecoilValue(authenticatedUserAtom)

  return (
    <Stack
      width="100vw"
      height="100vh"
      justifyContent="center"
      alignItems="center"
      sx={{
        background: COLORS.PURE_WHITE,
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 9999,
      }}>
      <AstronautGraphic />

      <Typography variant="h3" mb="12px">
        Your 30-day free trial has expired.
      </Typography>
      <Typography variant="pS">Subscribe to continue using JelledAI’s features.</Typography>

      <Button
        variant="contained"
        color="primary"
        sx={{
          mt: 4,
          mb: 4,
        }}
        onClick={() => {
          if (!user?.subscription?.stripe_management_url) {
            return
          }
          window.open(user?.subscription?.stripe_management_url, '_self')
        }}>
        Subscribe
      </Button>

      <Typography
        variant="pS"
        sx={{
          color: COLORS.GRAY_1,
        }}>
        If you want to delete your account, please proceed to{' '}
        <a
          href="/organization/billing"
          style={{
            textDecoration: 'underline',
          }}>
          Settings
        </a>
        .
      </Typography>
    </Stack>
  )
}

export default TrialEnded
